// extracted by mini-css-extract-plugin
module.exports = {"nav_box":"nav_box-1DDtVq_m","nav":"nav-2sgjEBc8","nav_piaohong":"nav_piaohong-1RCjgCOq"};